import React from 'react';
import { NavLink } from 'react-router-dom';

import classes from './NavigationItem.css';

const navigationItem = (props) => {

  let item = null;

  if (props.itemType === "Link") {
    item = (
      <NavLink
        to={props.link}
        exact
        activeClassName={classes.active}
        style={{display: "flex", alignItems: "center"}}>
        <p className={classes.NavLinkText}>{props.children}</p>
      </NavLink>
    );
  } else if (props.itemType === "Action") {
    item = (
      <button onClick={props.clicked}>
        {props.children}
      </button>
    );
  }

  return (
    <li className={classes.NavigationItem}>
      {item}
    </li>
  );
}

export default navigationItem;



// WEBPACK FOOTER //
// ./src/components/Navigation/NavigationItems/NavigationItem/NavigationItem.js